// Vista login. Estructura idéntica a mockups/login.html.

import { ApiError } from '../api/client.js';
import { icon } from '../components/icons.js';
import { login } from '../state/auth.js';
import { navigate } from '../router.js';

export function loginView() {
  return {
    mount(root) {
      root.innerHTML = `
        <div class="app">
          <main class="content" style="padding:0;">
            <div class="login-wrap">
              <div class="brand">
                <div class="logo" aria-hidden="true">P</div>
                <h1>Picking</h1>
                <p class="tagline">Empaquetado de pedidos · Almacén</p>
              </div>

              <form id="login-form" novalidate>
                <div class="field">
                  <label for="username">Usuario</label>
                  <input id="username" name="username" type="text" inputmode="text"
                         autocapitalize="none" autocomplete="username"
                         placeholder="ej. jlopez" required />
                </div>
                <div class="field" style="margin-top:1rem;">
                  <label for="password">Contraseña</label>
                  <input id="password" name="password" type="password"
                         autocomplete="current-password" required />
                </div>

                <div id="login-error" class="alert --error" hidden
                     style="margin-top:1rem;border-top:none;padding:0.6rem 0.85rem;">
                  <div class="ico">${icon('octagon-x', { size: 22 })}</div>
                  <div class="body"><strong id="login-error-msg"></strong></div>
                </div>

                <button class="btn --primary --block --lg" type="submit" id="login-submit"
                        style="margin-top:1rem;">Entrar</button>

                <p class="hint" style="color:var(--c-fg-muted);font-size:var(--fs-xs);text-align:center;margin-top:1rem;">
                  Usa tus credenciales habituales.
                </p>
              </form>
            </div>
          </main>
        </div>`;

      const form = root.querySelector('#login-form');
      const errBox = root.querySelector('#login-error');
      const errMsg = root.querySelector('#login-error-msg');
      const submit = root.querySelector('#login-submit');

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errBox.hidden = true;
        const fd = new FormData(form);
        const username = String(fd.get('username') || '').trim();
        const password = String(fd.get('password') || '');
        if (!username || !password) {
          errMsg.textContent = 'Rellena usuario y contraseña.';
          errBox.hidden = false;
          return;
        }
        submit.disabled = true;
        submit.textContent = 'Entrando…';
        try {
          const res = await login(username, password);
          if (res?.must_set_password) {
            // Primer login del operario: pasamos username en el hash para
            // que la vista set-password lo recoja sin tener que retipearlo.
            navigate(`#/set-password?u=${encodeURIComponent(username)}`, { replace: true });
            return;
          }
          navigate('#/pedidos', { replace: true });
        } catch (e) {
          const msg = e instanceof ApiError && e.status === 401
            ? 'Usuario o contraseña incorrectos.'
            : (e?.message || 'No se pudo iniciar sesión.');
          errMsg.textContent = msg;
          errBox.hidden = false;
          submit.disabled = false;
          submit.textContent = 'Entrar';
        }
      });

      // Auto-focus username — relevante en móvil tras volver del logout.
      setTimeout(() => root.querySelector('#username')?.focus(), 50);
    },
    unmount() { /* nada que limpiar */ },
  };
}
